const carpenterService = {
  title: "Carpenter",
  icon: "🪚",
  shortDescription:
    "Door, lock, hinge, furniture, shelf, fitting, and minor woodwork support.",
  longDescription:
    "Book verified carpentry help for basic repairs, fittings, adjustments, installations, and home woodwork support. Pricing depends on scope and material involvement.",
  consultationNote:
    "Material-heavy or custom fabrication jobs may require inspection before final estimate.",
  responsePromise:
    "Platform attempts structured assignment based on work nature and location.",
  warrantyPolicy:
    "Revisit or support eligibility depends on job type, existing condition, and material handling.",
  subServices: [
    {
      id: "carpenter-door-alignment",
      title: "Door Alignment",
      icon: "🚪",
      group: "Doors",
      description:
        "Fix door closing issue, rubbing edge, alignment shift, or minor movement problem.",
      basePrice: 249,
      priceType: "fixed",
      duration: "30-60 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "carpenter-lock-installation",
      title: "Lock Installation / Replacement",
      icon: "🔐",
      group: "Doors",
      description:
        "Install or replace door lock, latch, tower bolt, or similar hardware fitting.",
      basePrice: 249,
      priceType: "fixed",
      duration: "30-60 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "carpenter-hinge-repair",
      title: "Hinge Repair / Replacement",
      icon: "🪛",
      group: "Doors",
      description:
        "Repair or replace loose, damaged, or noisy hinge in door, cabinet, or shutter.",
      basePrice: 149,
      priceType: "fixed",
      duration: "20-45 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "carpenter-shelf-installation",
      title: "Wall Shelf Installation",
      icon: "🧱",
      group: "Shelves & Storage",
      description:
        "Install wall-mounted shelf or board unit with basic support alignment.",
      basePrice: 299,
      priceType: "starts_at",
      duration: "45-75 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "carpenter-furniture-minor-repair",
      title: "Furniture Minor Repair",
      icon: "🪑",
      group: "Furniture",
      description:
        "Repair loose joint, wobble issue, minor breakage, or fitting weakness in furniture.",
      basePrice: 299,
      priceType: "starts_at",
      duration: "45-75 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "carpenter-cabinet-adjustment",
      title: "Cabinet / Drawer Adjustment",
      icon: "🗄️",
      group: "Furniture",
      description:
        "Fix alignment, opening issue, track issue, or drawer fitting movement problem.",
      basePrice: 199,
      priceType: "fixed",
      duration: "30-45 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "carpenter-curtain-rod-install",
      title: "Curtain Rod Installation",
      icon: "🪟",
      group: "Accessories",
      description:
        "Install curtain rod brackets and support fittings securely on wall.",
      basePrice: 199,
      priceType: "fixed",
      duration: "30-45 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "carpenter-inspection",
      title: "Woodwork Inspection",
      icon: "🔍",
      group: "Inspection",
      description:
        "Inspection visit for custom furniture, major repair, or modification planning.",
      basePrice: 249,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
  ],
};

export default carpenterService;